import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { inject, observer } from 'mobx-react';
import RootStore, { ROOT_STORE } from 'src/stores/rootStore';
import nl2br from 'react-nl2br';

interface IAlertPopupComponentProps {
  id: string;
  title?: string;
  message?: string;
  actionString?: string;
  onSubmit?: () => void;
};

interface IAlertPopupComponentInjectedProps {
  [ROOT_STORE]: RootStore;
}

export const AlertPopupComponent: React.FC<IAlertPopupComponentProps> = inject(ROOT_STORE)(observer(({ id, title, message, actionString, onSubmit, ...props }) => {
  const { t } = useTranslation();
  const { rootStore: { popupStore } } = props as IAlertPopupComponentInjectedProps;
  // tslint:disable-next-line: variable-name
  const _actionString = actionString ?? t('shared.actionString');
  const onClickOk = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    if (onSubmit !== undefined) {
      onSubmit();
    };
    popupStore.destroy(id);
  }
  return (
    <div className='popup-wrap' style={{ top: '49%', transform: 'translateY(-50%)' }}>
      <p className='popup-logo'>commtown</p>
      {title !== undefined && <p className='popup-txt1'>{nl2br(title)}</p>}
      {message !== undefined && <p className='popup-txt2'>{nl2br(message)}</p>}
      <p className='popup-btn btn-single'>
        <a onClick={onClickOk} className='btn-bk'>{_actionString}</a>
      </p>
    </div>
  )
}));



// WEBPACK FOOTER //
// ./src/components/layout/popup/alert.tsx